import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { ScaffoldDialogRef } from '@app/framework/dialog/scaffold-dialog.service';
import { ZipService } from '@scaffold/services/zip.service';
import { NotificationsService } from '@services/notifications.service';
import { TranslationService } from '@services/translation.service';

@Component({
    selector: 'app-preview-frame',
    templateUrl: './preview-frame.component.html',
    styleUrls: ['./preview-frame.component.scss'],
    standalone: false
})
export class PreviewFrameComponent implements OnInit {
  url: string;
  data: any = {};
  constructor(
    private notification: NotificationsService,
    public dialogRef: ScaffoldDialogRef /*, private http: HttpUtilService*/,
    private zipService: ZipService,
    private cd: ChangeDetectorRef,
    private translationService: TranslationService
  ) {}
  image = false;
  doc = false;
  docURL = '';
  isLoading = true;
  pdf;
  @Input() isDisabled = true;
  ngOnInit() {
    this.url = this.data.url;

    console.log(this);
    const title = this.data.item?.data?.title || this.data.title;
    if (title.match(/\.(jp.*g|png|gif|bmp|jfif|svg)$/gi)) {
      this.isLoading = false;
      this.image = true;
    }

    if (title.match(/\.pdf$/gi)) {
      this.pdf = true;
    }

    /* else if (this.data.title.match(/\.doc/)) {
      this.doc = true
      this.http.request("GET", "api/"+ this.data.url).subscribe(d => {
        console.log(d);
        this.docURL = d.data.url;
      });
    }*/
    if (!this.image && !this.pdf) {
      this.downloadFile();
      this.dialogRef.close();
    }
  }

  loadIframe($event) {
    this.isLoading = false;
    this.cd.detectChanges();
  }

  getURL() {
    let url = this.url;
    if (this.doc)
      url = 'https://view.officeapps.live.com/op/embed.aspx?src=' + this.docURL;
    return url;
  }

  async downloadFile(e?) {
    // your_file_is_preparing_to_download
    const text = this.translationService.getTranslatedContent(
      'your_file_is_preparing_to_download',
      'Your File is Preparing to Download'
    );
    this.notification.popNotification('', text);
    e?.stopPropagation();
    let url = this.data?.item?.data?.url;
    let destination = url
      ?.split('/')
      ?.splice(1, url.split('/').length - 1)
      ?.join('/');
    const file = { destination, title: this?.data?.item?.data?.title, url };

    e?.preventDefault();
    this.zipService.zipFiles([file], [], this.data['prefix'], true);
  }

  close(isBackdrop?) {
    if (isBackdrop && this.data['dontCloseOnClick']) return;
    this.dialogRef.close();
  }
}
